export enum ModelPropertyType {
  String = "String",
  Integer = "Integer",
  Float = "Float",
  Boolean = "Boolean",
  Date = "Date",
  File = "File",
  Reference = "Reference",
}


export interface ModelPropertyInterface {
  name: string;
  type: ModelPropertyType;
  required?: boolean;
  isArray?: boolean;
  reference?: string;
  unique?: boolean;
  enum?: unknown[];
  schema?: ModelPropertyInterface[];
  default?: unknown | string | boolean | number;
  index?: boolean;
  min?: number;
  max?: number;
  match?: string;
  minLength?: number;
  maxLength?: number;
  minItems?: number;
  maxItems?: number;
  /**
   * Role-based access control for this property.
   * Array of role type names from the global RBAC config (MetaDataInterface.rbac.roles).
   * A "public" role is always implicitly available.
   * Displayed as a multi-select dropdown in the property editor.
   */
  access?: string[];
}